import Input from "./input.vue";
export default {
  name: "WizardInput",
  components: {
    Input
  },
  props: {
    active: [String, Object, Boolean, Number],
    name: !String,
    type: String,
    validate: Function,
    value: [String, Number, Boolean],
    suggested: Boolean
  },
  data() {
    return {
      state: {
        val: this.$refs.value,
        valid: true,
        hasFocus: false
      }
    };
  },
  computed: {
    valid() {
      return this.state.valid && this.value;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", this.state.val = val);
    },
    onValidate(status) {
      this.state.valid = status;
    },
    onFocus() {
      this.state.hasFocus = true;
    },
    onBlur() {
      this.state.hasFocus = false;
    }
  }
};